export const generalMessages = {
  en: {
    exportToCsv: 'Export to CSV',
    description: 'Description',
    startDate: 'Start',
    endDate: 'End',
    creator: 'Creator',
    createdAt: 'Created',
    name: 'Name',
    action: 'Actions',
    forgotPin: 'Forgot PIN',
    pinReminderSent: 'PIN reminder sent successfully',
    showAll: 'Show All',
    price: 'Price',
    all: 'All',
    firstName: 'First Name',
    lastName: 'Last Name',
    type: 'Type',
    cost: 'Cost',
    amount: 'Amount',
    date: 'Date',
    email: 'Email',
    phone: 'Phone',
    phoneNumber: ' Phone Number',
    position: 'Position',
    cashierSiteSelection: 'Cashier Site Selection',
    plate: 'Plate',
    make: 'Make',
    model: 'Model',
    year: 'Year',
    color: 'Color',
    vin: 'VIN',
    upload: 'Upload',
    image: 'Image',
    video: 'Video',
    select: 'Select',
    uploadFile: 'Upload file',
    uploadMedia: 'Upload media',
    uploadAttachment: 'Upload attachment',
    uploading: 'Uploading',
    uploadFailed: 'Upload failed',
    dragDropFiles: 'Drag & drop files here, or',
    browseFiles: 'browse files',
    uploadPhotoVideoOnly: 'Please upload photo or video files only.',
    file: 'File',
    issue: 'Issue',
    issueDate: 'Issue date',
    issueCreated: 'Issue created',
    back: 'Back',
    cancel: 'Cancel',
    previous: 'Previous',
    next: 'Next',
    ok: 'Ok',
    All: 'All',
    vehicle: 'Vehicle',
    location: 'Location',
    photos: 'Photos',
    loading: 'Loading...',
    loadingSites: 'Loading sites',
    videos: 'Videos',
    documents: 'Documents',
    customerInfo: 'Customer Info',
    vehicleInfo: 'Vehicle Info',
    edit: 'Edit',
    delete: 'Delete',
    archive: 'Archive',
    unarchive: 'Unarchive',
    Denied: 'Denied',
    Completed: 'Completed',
    accept: 'Accept',
    unknown: 'Unknown',
    send: 'Send',
    decline: 'Decline',
    start: 'Start',
    goBack: 'Go Back',
    save: 'Save',
    open: 'Open',
    end: 'End',
    noImage: 'No image available',
    notAvailable: 'N/A',
    expired: 'Expired',
    due: 'Due',
    id: 'Id',
    url: 'URL',
    item: 'Item',
    Other: 'Other',
    search: 'Search...',
    site: 'Site',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This week',
    lastWeek: 'Last week',
    thisMonth: 'This month',
    lastMonth: 'Last month',
    yearToDate: 'Year to date',
    customRange: 'Custom Range',
    dateFilter: 'Date Filter',
    custom: 'Custom',
    units: 'Units',
    field: 'Field',
    oldValue: 'Old Value',
    newValue: 'New Value',
    noHistory: 'No history',
    signOut: 'Sign Out',
    history: 'History',
    employeeSingular: 'employee',
    employeePlural: 'employees',
    hourSingular: 'hour',
    hourPlural: 'hours',
    minuteSingular: 'minute',
    minutePlural: 'minutes',
    days: 'days',
  },
};

export default generalMessages;
